import * as definitions from 'store/definitions/video';
import { LOCATION_CHANGE } from 'connected-react-router';

const formState = {
  id: null,
  title: '',
  videoUrl: '',
  videoId: '',
  isActive: false,
};

const initialState = {
  collection: [],
  total: 0,
  currentPage: 1,
  totalPages: 0,
  search: '',
  form: formState,
};

function Video(state = initialState, action) {
  switch (action.type) {
    case definitions.FETCH_VIDEOS_FULFILLED: {
      return {
        ...state,
        collection: action.payload.data,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
        search: action.payload.search,
      };
    }
    case definitions.FETCH_VIDEO_FULFILLED: {
      return {
        ...state,
        form: action.payload,
      };
    }
    case LOCATION_CHANGE:
      return {
        ...state,
        form: formState,
      };
    default:
      return state;
  }
};

export default Video;